import { render, staticRenderFns } from "./Robots.vue?vue&type=template&id=37793dd9&scoped=true"
import script from "./Robots.vue?vue&type=script&lang=js"
export * from "./Robots.vue?vue&type=script&lang=js"
import style0 from "./Robots.vue?vue&type=style&index=0&id=37793dd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37793dd9",
  null
  
)

export default component.exports